/**
 * Contratos de navegação da autenticação compartilhados entre o contexto de
 * auth, a tela de login e os guards de rota — fonte única para não divergirem.
 */

/** Rota de entrada do app após autenticar (login, 2FA, impersonação admin). */
export const POST_LOGIN_ROUTE = "/dashboard";

/** Rota da troca obrigatória de senha (senha provisória). */
export const CHANGE_PASSWORD_ROUTE = "/change-password";

/** Tela de login (rota de visitante, guardada pelo GuestRoute). */
export const LOGIN_ROUTE = "/login";

/** Recuperação de senha. */
export const FORGOT_PASSWORD_ROUTE = "/forgot-password";

/** Query params que o painel admin envia em "acessar como assinante". */
export const ADMIN_IMPERSONATION_TOKEN_PARAM = "admin_impersonation_token";
export const ADMIN_RETURN_TO_PARAM = "admin_return_to";

/** Login depois do encerramento da conta: a tela mostra a confirmação. */
export const ACCOUNT_CLOSED_PARAM = "conta";
export const ACCOUNT_CLOSED_VALUE = "encerrada";
export const ACCOUNT_CLOSED_LOGIN_ROUTE = `${LOGIN_ROUTE}?${ACCOUNT_CLOSED_PARAM}=${ACCOUNT_CLOSED_VALUE}`;
